import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=ea36bb80&lang=css"

const __exports__ = script;

export default __exports__